import { ConnectorManagerContract } from '@terra/shared-contracts-connector-manager';
import { createTerraOrpcClient } from '@terra/shared-utils';

const SERVICE_NAME = 'orchestrator';

export const connectorManagerClient = createTerraOrpcClient({
  contract: ConnectorManagerContract,
  serviceName: SERVICE_NAME,
});
